import styled from "@emotion/styled";
import { TextareaAutosize, FormControl } from "@mui/material";
import classNames from "classnames";
import React from "react";
import { Controller } from "react-hook-form";
import { DebounceInput } from "react-debounce-input";

const Styled = styled.div`
  margin-bottom: 24px;
  position: relative;
  padding: 0;
  border: 1px solid transparent;

  &.isTextarea {
    height: auto !important;
    max-height: 250px;
    overflow-y: auto;
  }

  .MuiFormControl-root {
    height: 100%;
  }

  .input-container {
    margin-bottom: 0;
    display: flex;
    align-items: center;
    border-radius: 10px;
    gap: 5px;
    overflow: hidden;
    height: 100%;
    max-height: 100% !important;

    input[type="password"] {
      font-family: Verdana;
      font-weight: 700;
      letter-spacing: 0.125em;
    }

    input,
    .textarea {
      padding: 15px 10px;
      flex: 1;
      height: 100%;
      border: none;
      outline: none;
      font-size: 14px;
      min-width: 0;
      max-height: 45px;
    }
    .textarea {
      resize: none;
    }
  }
  .error-message {
    color: #e00;
    display: block;
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    line-height: 1;
    font-size: 12px;
  }

  .label-top {
    color: #e00;
    display: block;
    position: absolute;
    top: calc(0% + -18px);
    left: 0;
    line-height: 1;
    font-size: 12px;
  }
  .label-top1 {
    color: black;
    display: block;
    position: absolute;
    top: calc(0% + -18px);
    left: 0;
    line-height: 1;
    font-size: 12px;
  }

  @media only screen and (max-width: 1536px) {
    height: 46px;
  }
`;

const CustomInput = ({ control, name = "", labelTop = "", showError = true, rightContent = null, style = {}, messages = {}, onChange, rules = {}, variant = "input", className, ...rest }) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <Styled
          className={classNames("input " + className, {
            error: !!error,
            isTextarea: variant === "textarea",
          })}
          style={style}
        >
          {error ? <div className="label-top">{labelTop}</div> : <div className="label-top1">{labelTop}</div>}
          <FormControl fullWidth>
            <div className="input-container">
              {variant === "textarea" && (
                <TextareaAutosize
                  {...field}
                  onChange={(e) => {
                    field.onChange(e);
                    onChange?.(e.target.value);
                  }}
                  className="textarea"
                  {...rest}
                />
              )}
              {variant === "waiting" && (
                <DebounceInput
                  {...field}
                  onChange={(e) => {
                    field.onChange(e);
                    onChange?.(e.target.value);
                  }}
                  minLength={rest.minLength || 2}
                  debounceTimeout={rest.timeout || 300}
                  onWheel={(e) => e.currentTarget.blur()}
                  {...rest}
                />
              )}
              {variant === "input" && (
                <input
                  {...field}
                  onChange={(e) => {
                    field.onChange(e);
                    onChange?.(e.target.value);
                  }}
                  onWheel={(e) => e.currentTarget.blur()}
                  {...rest}
                />
              )}
              {rightContent}
            </div>
            {showError && error && <div className="label error-message">{error.message || messages[error.type]}</div>}
          </FormControl>
        </Styled>
      )}
    />
  );
};

export default CustomInput;
